// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__ROEkX","title":"Images90_title__98jcx","images":"Images90_images__S0652"};